import { useCallback } from "react";
import { Box, Card, Typography } from "@mui/material";
import { ClaimsStyles } from "./ClaimsStyles";
import ClaimCard from "./ClaimCard/ClaimCard";
import rightArrowIcon from "../../../assets/viewAllArrow.svg";
import { IClaimsData } from "../../../models/user/dashboard/Dashboard";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface IProps {
  claimsData: IClaimsData;
}

const Claims: React.FC<IProps> = ({ claimsData }) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const getActiveClaims = useCallback(() => {
    if (claimsData && claimsData.claimList && claimsData.claimList.length > 0) {
      let claims = [...claimsData.claimList];
      let activeClaims = claims
        .filter(
          (claim) =>
            claim.carrierClaimNo && claim.carrierClaimStatus !== "Closed"
        )
        .sort(
          (a, b) =>
            new Date(b.initiatedDate).getTime() -
            new Date(a.initiatedDate).getTime()
        );
      return activeClaims;
    } else {
      return [];
    }
  }, [claimsData]);

  const handleViewAllClaims = () => {
    // setViewAllClaimsDialogOpen(true);
    navigate("/customer/claims");
  };

  return claimsData ? (
    <>
      <Box sx={ClaimsStyles.claimsContainer}
        id="customerdashboard_claims-container"
        data-test-id="test-customerdashboard_claims-container"
        aria-label="Claims section"
      >
        <Box sx={ClaimsStyles.claimCardsContainerHeader}
          id="customerdashboard_claims-header"
          data-test-id="test-customerdashboard_claims-header"
          aria-label="Claims header"
        >
          <Typography sx={ClaimsStyles.heading}
            id="customerdashboard_claims-heading"
            data-test-id="test-customerdashboard_claims-heading"
            aria-label="Claims heading with count"
          >
            {t("My Claims")} (
            {claimsData?.claimCount
              ? claimsData.claimCount < 10
                ? `0${claimsData?.claimCount}`
                : claimsData?.claimCount
              : "0"}
            )
          </Typography>
          {claimsData &&
          claimsData.claimList &&
          claimsData.claimList.length > 0 ? (
            <Box sx={ClaimsStyles.viewAll} onClick={handleViewAllClaims}
              id="customerdashboard_claims-viewall-container"
              data-test-id="test-customerdashboard_claims-viewall-container"
              aria-label="View all claims section"
            >
              <Typography 
                id="customerdashboard_claims-viewallclaims-text"
                data-test-id="test-customerdashboard_claims-viewallclaims-text"
                aria-label="Click to view all claims"
                sx={ClaimsStyles.viweAllText}>
                {t("View all claims")}
              </Typography>
              <img 
                id="customerdashboard_claims-viewall-rightarrow-img"
                data-test-id="test-customerdashboard_claims-viewall-rightarrow-img"
                aria-label="Right arrow icon for view all claims"
                src={rightArrowIcon} 
                alt="right-arrow-icon" 
              />
            </Box>
          ) : (
            <></>
          )}
        </Box>
        {getActiveClaims().length > 0 ? (
          <Box sx={ClaimsStyles.claims}
            id="customerdashboard_claims-active-list"
            data-test-id="test-customerdashboard_claims-active-list"
            aria-label="List of active claims"
          >
            {getActiveClaims().map((claim) => (
              <ClaimCard
                claim={claim}
                key={`dash-claim-${claim.carrierClaimNo}`}
              />
            ))}
          </Box>
        ) : (
          <Card sx={ClaimsStyles.noClaimsCard}
            id="customerdashboard_claims-empty-card"
            data-test-id="test-customerdashboard_claims-empty-card"
            aria-label="No active claims available message"
          >
            <Typography 
              sx={ClaimsStyles.noClaimsText}
              id="customerdashboard_claims-empty-text"
              data-test-id="test-customerdashboard_claims-empty-text"
              aria-label="No active claims available"
            >
              {t("No Active Claims Available")}
            </Typography>
          </Card>
        )}
      </Box>
    </>
  ) : (
    <></>
  );
};

export default Claims;
